import React from "react";
import { Route, Switch } from "react-router-dom";
import { SolutionList, NetworkList, FocusedMarketList, BannerList, CareerListing, NewsList } from "..";
import { APP_ROUTES } from "../../../constants";
import { PageWithSubRoute } from "../../components";

import { PageManagementRoutes } from "./PageManagementRoutes";
import TechnologyList from "./Technology/TechnologyList";

const PageManagementPresenter: React.FC = (props) => {
  return (
    <PageWithSubRoute routeMenu={PageManagementRoutes}>
      <Switch>
        {PageManagementRoutes.map((route) => {
          return <Route key={route.path} path={route.path} exact render={route.renderComponent} />;
        })}

        {/* những route không có trong menu */}
        <Route path={APP_ROUTES.PAGEMANAGEMENT.BANNER.DETAIL} exact component={BannerList} />
        <Route path={APP_ROUTES.PAGEMANAGEMENT.SOLUTION.DETAIL} exact component={SolutionList} />
        <Route path={APP_ROUTES.PAGEMANAGEMENT.NEWS.DETAIL} exact component={NewsList} />
        <Route path={APP_ROUTES.PAGEMANAGEMENT.FOCUSED_MARKET.DETAIL} exact component={FocusedMarketList} />
        <Route path={APP_ROUTES.PAGEMANAGEMENT.NETWORK.DETAIL} exact component={NetworkList} />
        <Route path={APP_ROUTES.PAGEMANAGEMENT.CAREER.DETAIL} exact component={CareerListing} />
        <Route path={APP_ROUTES.PAGEMANAGEMENT.TECHNOLOGY.DETAIL} exact component={TechnologyList} />
      </Switch>
    </PageWithSubRoute>
  );
};

export default PageManagementPresenter;
